// TODO: remove this in favor of the grimoire version
type WithFullName = Record<'firstName' | 'lastName', string>
export const fullName = (user: WithFullName): string =>
  `${user.firstName} ${user.lastName}`
